import { apiRootUrl } from '../assets/constants';
import { showApiErrorAlert } from '../functions/api';

// types
type CommentType = {
    body: string,
    userId: number,
}

type SuccessResponse = {
    status: number;
    data: {
        commentId: number;
        topicId: number;
        body: string;
        userId: number;
        userName: string;
        postTime: string;
    };
}

type ErrorResponse = {
    status: number,
    error: {
        code: string,
        message: string,
        validationErrors: {
            key: string,
            message: string
        }[]
        | null
    }
}

type ResponseType = SuccessResponse | ErrorResponse;

// コメントの取得
export const getComment = (commentId: string) => {
    const api = apiRootUrl + "/comments/" + commentId;
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "コメントの取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return result.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

// コメントの投稿
export const addComment = (topicId: string, content: CommentType): Promise<ResponseType | void> => {
    const api = apiRootUrl + "/topics/" + topicId + /comments/;
    const options = {
        body: JSON.stringify(content),
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "コメントの投稿");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 422) {
                throw new Error(result.status);
            }
            // 成功もしくは入力エラーが検出された場合は、結果を返す
            if (result.status === 200 || result.status === 422) {
                return result;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

// コメントの更新 
export const updateComment = (commentId: string, topicId: string, content: CommentType): Promise<ResponseType | void> => {
    const api = apiRootUrl + "/topics/" + topicId + "/comments/" + commentId;
    const options = {
        body: JSON.stringify(content),
        headers: {
            "Content-Type": "application/json",
        },
        method: "PUT",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 403 || result.status === 404 || result.status === 500) {
                showApiErrorAlert(result.status, "コメントの更新");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 422) {
                throw new Error(result.status);
            }
            // 成功もしくは入力エラーが検出された場合は、結果を返す
            if (result.status === 200 || result.status === 422) {
                return result;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

// コメントの削除
export const deleteComment = (commentId: string, topicId: string) => {
    const api = apiRootUrl + "/topics/" + topicId + "/comments/" + commentId;;
    const options = {
        method: "DELETE",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 404 || result.status === 500) {
                showApiErrorAlert(result.status, "コメントの削除");
            }
            // エラー処理
            if (result.status !== 200 && result.status !== 204) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return result;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
